/** @param {Record<string, unknown>} prev @param {Record<string, unknown>} patch */
export function patchDesignDnaDemoMessage(prev, patch) {
  return {
    ...prev,
    text: '',
    ...patch,
  }
}

/** @param {Function} setMessagesByThreadId @param {string} tid @param {string} pendingId @param {Record<string, unknown>} patch */
export function updatePendingDesignDnaDemoMessage(setMessagesByThreadId, tid, pendingId, patch) {
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = patchDesignDnaDemoMessage(list[idx], patch)
    return { ...inner, [tid]: next }
  })
}
